import { FC, memo } from "react";
import clsx from "clsx";
import styles from "./HackathonBanner.module.css";

import { useParams } from "react-router-dom";
import { useHackathon } from "api/hackathon";
import { getImageUrl } from "utils/urlParser";
import useImageLoaded from "hooks/useImageLoaded";
import { Skeleton } from "antd";
// import { routesEnum } from "pages/Routes";

// interface LogoHeaderProps {
//   type?: "image" | "text";
//   value?: any;
//   color?: any;
//   align?: "left" | "center";
// }

// const HeaderLogo: FC<LogoHeaderProps> = ({
//   value,
//   type = "text",
//   align = "center",
//   color = "#ffffff",
// }) => {
//   return type === "text" ? (
//     <div style={{ color }} className={clsx(styles.logoTitle, styles[align])}>
//       {value}
//     </div>
//   ) : (
//     <img src={value} className={clsx(styles.logoImage, styles[align])} />
//   );
// };

const HackathonBanner: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: hackathon } = useHackathon(id, { enabled: false });

  const design = hackathon?.design;
  let backgroundImage = getImageUrl(design?.backgroundImage);
  const backgroundColor = design?.backgroundColor || "#1d2048";
  const backgroundPosition = design?.backgroundPosition || "center";
  let logoImage = getImageUrl(design?.logoImage) || hackathon?.essentials?.name;
  const [ref, loaded, onLoad] = useImageLoaded();

  if (!hackathon) {
    logoImage = "Join BITCOIN HACKATHON NOW";
    backgroundImage = "";
  }

  return (
    <div
      className={clsx(
        styles.root,
        backgroundPosition === "center" && styles.coverImg
      )}
      style={{
        background: loaded
          ? !design?.backgroundImage
            ? `url(/images/hkt/banner.png) center no-repeat`
            : `${backgroundColor}`
          : "rgba(190, 190, 190, 0.2)",
      }}
    >
      {!loaded && <Skeleton.Button active className={styles.skeleton} />}
      {!!backgroundImage && (
        <img
          src={backgroundImage}
          className={styles.headerImage}
          ref={ref}
          onLoad={onLoad}
          style={loaded ? {} : { display: "none" }}
        />
      )}
      <div className={clsx(styles.logoContainer, "container")} />
    </div>
  );
};

export default memo(HackathonBanner);
